import { optional } from '@makeabledk/vue-ui/support/helpers'

function getRequestedDelay(binding) {
    const delay = Object.keys(binding.modifiers).find((modifier) => modifier.indexOf('s') > -1)

    if (delay) {
        const factor = delay.indexOf('ms') > -1 ? 1 : 1000

        return parseInt(delay) * factor
    }

    return 0
}

function focus(el, binding) {
    setTimeout(() => el.focus(), getRequestedDelay(binding))
}

export default {
    mounted(el, binding) {
        if (optional(binding.value, true)) {
            focus(el, binding)
        }
    },

    updated(el, binding) {
        // If value changed from false --> true we'll apply focus. Otherwise ignore.
        if (optional(binding.value, true) && binding.oldValue === false) {
            focus(el, binding)
        }
    },
}
